// @flow

import React from 'react';
import bemify, { toModifiers } from 'bemify-js';

import Link from 'web-ssr/app/common/components/Link';
import Logo from 'web-ssr/app/common/components/Logo';
import SocialLinks from 'web-ssr/app/common/components/ContentFooter/SocialLinks';
import Text from 'web-ssr/app/common/components/Text';
import 'web-ssr/app/common/components/ContentFooter/Footer.scss';

const bem = bemify('footer');

type Props = {
  isLoggedIn: boolean,
  /**
   * Adjusts the footer to be compatible with 1200px design system layout.
   * This is a temporary fix until the new header is implemented.
   **/
  isDesignSystemFooter: boolean,
};

const Footer = (props: Props) => {
  const { isLoggedIn, isDesignSystemFooter } = props;

  return (
    <footer
      className={bem(
        toModifiers({ 'design-system-footer': isDesignSystemFooter })
      )}
    >
      <nav
        className={bem(
          '__primary-links',
          toModifiers({ 'design-system-footer': isDesignSystemFooter })
        )}
      >
        <Link
          className={bem('__link')}
          href={isLoggedIn ? '/app/billing/plans' : '/pricing'}
        >
          <Text kind="16 strong">{isLoggedIn ? 'Plans' : 'Pricing'}</Text>
        </Link>
        <Link className={bem('__link')} href="/help/">
          <Text kind="16 strong">Help</Text>
        </Link>
        <Link className={bem('__link')} href="/platform">
          <Text kind="16 strong">Developer Platform</Text>
        </Link>
        <Link className={bem('__link')} href="/press">
          <Text kind="strong">Press</Text>
        </Link>
        <Link className={bem('__link')} href="/jobs/">
          <Text kind="16 strong">Jobs</Text>
        </Link>
        <Link className={bem('__link')} href="/companies/">
          <Text kind="16 strong">Zapier for Companies</Text>
        </Link>
      </nav>

      <div className={bem('__logo')}>
        <Logo className={bem('__wiggle')} />
        <Text className={bem('__tagline')}>makes you happier :)</Text>
      </div>

      <div className={bem('__social')}>
        <Text className={bem('__social-title')} kind="small strong">
          Follow us
        </Text>

        <SocialLinks className={bem('__social-list')} />
      </div>

      <div className={bem('__secondary-links')}>
        <Text className={bem('__copyright')} kind="small">
          © {new Date().getFullYear()} Zapier Inc.
        </Text>
        <Link className={bem('__link', '--secondary')} href="/terms/">
          <Text kind="small">Terms</Text>
        </Link>
        <Link className={bem('__link', '--secondary')} href="/privacy/">
          <Text kind="small">Privacy</Text>
        </Link>
        <Link className={bem('__link', '--secondary')} href="/brand/">
          <Text kind="small">Brand</Text>
        </Link>
      </div>
    </footer>
  );
};

Footer.defaultProps = {
  isDesignSystemFooter: false,
};

export default Footer;
